import {enableProdMode} from '@angular/core';
import {appConfig} from './app/app.config';
import {environment} from '@env/environment';
import {AppComponent} from './app/app.component';
import {bootstrapApplication} from '@angular/platform-browser';
import * as Sentry from "@sentry/angular";

if (environment.production) {
  enableProdMode();
}

if (environment.enableSentry) {
  Sentry.init({
    dsn: 'https://4d3c6f9ff74a453c97873ed38d4a4ead@o4504043285774336.ingest.us.sentry.io/4504043289247744',
    integrations: [
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
        maskAllInputs: true,
      }),
    ],
    tracePropagationTargets: [
      environment.defaultConfig.baseApiUrl,
    ],
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    environment: environment.sentryEnvironment,
  });
}

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
